CoverageApp.Views.CoverageView = Backbone.View.extend({
    el: "#coverage-tool-container", 
    
    events: {
        'click #submitBtnCoverage': 'onStartSearch',
        'click .download-s3-button': 'startDownload'
    },

    initialize: function() {
        var self = this; // Define self for the ajax callback scope
        this.listenTo(this.model, 'change:status', this.render);
        this.listenTo(this.model, 'change:files', this.updateFileContainer);
        // this.listenTo(this.model, 'change:link', this.startDownload);
        $.ajax({
            url: '/assets/js/coverage_tool/03_templates/files.html',
            success: function(extTemplate) {
                self.template = _.template(extTemplate);
                // Trigger update if data already exists
                self.updateFileContainer();
            },
            error: function(err) {
                console.error('Failed to load template:', err);
            }
        });
    },

    onStartSearch: function(e) {        
        e.preventDefault(); // Stop form submission
    
        // Find the file input by ID or Class
        const fileInput = this.$('#uploadFile')[0]; // The [0] gets the raw HTML element
        const searchType = this.$('input[name="csv_search_type"]:checked').val();
        
        if (fileInput && fileInput.files.length > 0) {
            this.model.startProcess(fileInput, searchType);
        } else {
            alert("Please select a file first!");
        }
    },

    startDownload: async function(e) { 
        // on clicking on download-s3-button, this function will be triggered and 
        // an ajax in the model will be called which will create a signed url
        try {
            const id = $(e.currentTarget).data('id');
            await this.model.getDownloadLink(id);            
            const presignedUrl = await this.model.getDownloadLink(id);
            
            if (presignedUrl) {
                var downloadLink = document.createElement('a');
                downloadLink.href = presignedUrl.url;
                downloadLink.download = ''; 
                
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            } else {
                console.warn("Model updated, but link attribute remains empty.");
            }

        } catch (error) {
            console.error("Caught download execution error:", error);
        }
        // window.location.href = url;
    },

    render: function() {
        const status = this.model.get('status');
        const $btn = this.$('#submitBtn');

        if (status === 'uploaded_processing') {
            $btn.prop('disabled', true).text('Processing...');
            swal({
                type: "success",
                title: "Upload complete! We're preparing your data in the background",
                text: "You will receive the data in s3"
            })
        } else if (status === 'processing') {
            $('#message-box').text("Fetching data chunks...");
        } else if (status === 'completed') {
            $btn.prop('disabled', false).text('Search Companies');
        }
        $('#batchUploadForm').trigger("reset");
        return this;
    },
    
    updateFileContainer: function(downloads) {
        if (!this.template) return;
        
        // Get the data array from the model
        var fileData = this.model.get('files'); 
        
        // Pass the data to the template (wrapped in an object)
        this.$('.csv-upload-ibox').html(this.template({ items: fileData }));
    }
});